import {EmojiDict} from "../../../../gd/const/item-icon/emoji/emoji";
import React from "react";

type Props = {
    symbol      : string      // this is our system name (config)
    className?  : string
    size        : string        // size in pixels
}


// old used in reactions...
export default function EmojiSymbolDeprecated(props:Props) {

    const classes = Classes("ui5-emoji", props.className)

    return (
        <div className={classes} style={{fontSize: props.size+'px', width: props.size + "px", lineHeight: props.size + "px"}}>
            {props.symbol}
        </div>
    )

}